module.exports = __webpack_public_path__ + "static/media/PA_logo.c10970db.jpg";